import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';

import validators from 'utils/validators';
import FormCard from 'components/FormCard';
import AnimateButton from 'components/@extended/AnimateButton';
import Button from 'components/Button';
import React, { useEffect } from 'react';
import DadosDaProduto from './DadosDoProduto';
import * as actions from 'reducers/produtosOperacoes.reducer';
import Loader from 'components/Loader';
import MainCard from 'components/MainCard';
import { Box, Typography } from '@mui/material';
import MainLayout from 'layout/MainLayout/index';

import {
  actions as routeActions,
  types as routes
} from 'reducers/rotas.actions';

const Produto = () => {
  const dispatch = useDispatch();
  const produto = useSelector((state) => state.produtos.produto.data);
  const loading = useSelector((state) => state.produtos.produto.loading);

  const isEditMode = useSelector((state) => state.produtos.produto.isEditMode);

  const disabled = !isEditMode ? false : produto?.tipoSituacao !== 'A';

  const initialValues = {
    // Dados do Produto
    nomeOperacao: produto?.nomeOperacao ?? ''
  };

  const rules = {
    // Dados do Produto
    nomeOperacao: validators.string({ required: true })
  };

  const formProps = {
    ...useForm(),
    rules,
    initialValues: {
      ...initialValues
    },
    defaultValues: produto
  };

  useEffect(() => {
    if (!!produto) {
      formProps.reset({
        ...produto
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [produto]);

  const handleSubmit = (values) => {
    const payload = {
      ...values,
      dataAlteracao: new Date().toISOString(),
      dataCriacao: new Date().toISOString()
    };

    if (isEditMode) {
      dispatch(actions.editarProdutoRequest({ value: payload }));
    } else {
      dispatch(actions.criarProdutoRequest({ value: payload }));
    }
  };

  const handleGoBack = () => {
    dispatch(routeActions.redirectTo(routes.PRODUTOS));
  };

  if (loading) {
    return (
      <MainLayout>
        <Loader />
      </MainLayout>
    );
  }

  if (isEditMode && !produto?.idOperacao) {
    return (
      <MainLayout>
        <>
          <MainCard border={false} title={'Operação não encontrada'}>
            <Grid
              container
              style={{ marginTop: 20, justifyContent: 'end', marginBottom: 20 }}
              spacing={2}
            >
              <Grid item xs={12} md={4}>
                <AnimateButton>
                  <Button
                    disableElevation
                    fullWidth
                    size="large"
                    type="button"
                    variant="outlined"
                    color="secondary"
                    onClick={handleGoBack}
                  >
                    VOLTAR
                  </Button>
                </AnimateButton>
              </Grid>
            </Grid>
          </MainCard>
        </>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <form noValidate onSubmit={formProps.handleSubmit(handleSubmit)}>
        <MainCard
          contentSX={{
            paddingLeft: 1,
            paddingRight: 1
          }}
          border={false}
          title={
            !isEditMode ? (
              'Nova Operação'
            ) : (
              <Box>
                <Typography variant="h2">{produto?.nomeOperacao}</Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  Operação
                </Typography>
              </Box>
            )
          }
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              gap: 2
            }}
          >
            <Box sx={{ flex: 1 }}>
              <FormCard title="DADOS DA OPERAÇÃO" style={{ flex: 1 }}>
                <DadosDaProduto formProps={formProps} disabled={disabled} />
              </FormCard>
            </Box>
          </Box>
        </MainCard>

        <Grid
          container
          style={{ marginTop: 20, justifyContent: 'end', marginBottom: 20 }}
          spacing={2}
        >
          <Grid item xs={12} md={4}>
            <AnimateButton>
              <Button
                disableElevation
                fullWidth
                size="large"
                type="button"
                variant="outlined"
                color="secondary"
                onClick={handleGoBack}
              >
                VOLTAR
              </Button>
            </AnimateButton>
          </Grid>
          <Grid item xs={12} md={4}>
            <AnimateButton>
              <Button
                disabled={disabled}
                disableElevation
                fullWidth
                size="large"
                variant="contained"
                color="primary"
                type="submit"
              >
                SALVAR
              </Button>
            </AnimateButton>
          </Grid>
        </Grid>
      </form>
    </MainLayout>
  );
};

export default Produto;
